import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./css/App.css";
import "./css/Workshops.css";
import "./css/Cards_maerkte.css";
import "./css/Uebermich.css";
import "./css/Footer.css";
import "./css/Datenschutz.css";
import "./css/navigation.css";
import "./css/Kontakt.css";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error('Root-Element mit id="root" wurde nicht gefunden. Prüfe public/index.html!');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
